import React from 'react';

interface AuthLayoutProps {
  children: React.ReactNode;
  title: string;
  description: string;
}

// The two brand grounds, side by side: a black-veiled course photo carrying white and gold on the
// left, a plain white panel carrying ink on the right. The overlay was gray-900 at 40%, which left
// the photo bright enough that white text sat on unpredictable contrast; black at 65% makes the
// heading reliable no matter what the image is doing behind it.
const AuthLayout: React.FC<AuthLayoutProps> = ({
  children,
  title,
  description,
}) => (
  <div className="bg-white">
    <div className="flex h-screen justify-center">
      {/* Background Image */}
      <div
        className="hidden bg-cover bg-center lg:block lg:w-2/3"
        style={{
          backgroundImage: 'url(/images/login-background.jpg)',
        }}
      >
        <div className="flex h-full items-center bg-secondary/65 px-20">
          <div>
            {/* The white colourway, on the dark ground it is meant for. */}
            <img
              src="/images/logo-white.png"
              alt="GolfPlayed"
              className="mb-10 h-14 w-auto"
            />
            {/* A short gold rule. Gold as a rule, never as the text itself. */}
            <span className="mb-6 block h-1 w-16 bg-primary" />
            <h2 className="max-w-measure font-display text-3xl font-bold text-white">
              {title}
            </h2>
            <p className="mt-4 max-w-measure text-lg text-white/70">
              {description}
            </p>
          </div>
        </div>
      </div>
      {/* Form Section */}
      <div className="mx-auto flex w-full max-w-md items-center px-6 lg:w-2/6">
        <div className="flex-1">
          <div className="text-center">
            {/* The black colourway, on white. Capped so it cannot render at its natural width. */}
            <img
              src="/images/logo-black.png"
              alt="GolfPlayed"
              className="mx-auto mb-8 h-8 w-auto sm:h-12 lg:hidden"
            />
            {children}
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default AuthLayout;
